import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';

import { Subject, Observable } from 'rxjs';
import { JsonUtil } from '../../utils/json-util';
import { IOptionLabel } from '../../popover-dropdownlist/popover-dropdownlist.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-my-select',
  templateUrl: './my-select.component.html',
  styleUrls: ['./my-select.component.css']
})
export class MySelectComponent<T> implements OnInit, OnDestroy {

  @Input() options: T[];
  @Input() optionLabel: IOptionLabel[];
  optionSelected: T;
  subject: Subject<T>;
  jsonUtil: JsonUtil;

  constructor(
    private datePipe: DatePipe
  ) { 
    this.jsonUtil = new JsonUtil(datePipe);
  }

  getObservable(): Observable<T>  {
    if ( !this.subject ) {
      this.subject = new Subject();
    }

    return this.subject.asObservable();
  }

  finish(): void {
    this.complete();
  }
  complete(): void {
    if ( this.subject ) {
      this.subject.complete();
      this.subject = null;
    }
  }

  ngOnInit() {
    // this.subject = new Subject();
  }

  onChange(event: any) {
    if ( this.subject ) {
      this.subject.next(this.optionSelected);
    }
  }

  ngOnDestroy() {
    // this.subject.complete();
  }

  getOption(option: T): T {
    return this.jsonUtil.getOptionsLabel(option, this.optionLabel);
  }

}
